/**
 * pinnedClients + recentClients — wrappers tipados sobre useLocalStorageList.
 *
 * Day-1: persiste localmente por usuario (sem sync cross-device). Futuro:
 * mover pra DDB user-preferences se demanda surgir.
 */

import { useLocalStorageList } from './useLocalStorageList';

export const PINNED_MAX = 6;
export const RECENTS_MAX = 4;

const PINNED_KEY = 'aura.pinned.v1';
const RECENTS_KEY = 'aura.recent.v1';

export function usePinnedClients() {
  return useLocalStorageList({ key: PINNED_KEY, max: PINNED_MAX, mode: 'set' });
}

export function useRecentClients() {
  return useLocalStorageList({ key: RECENTS_KEY, max: RECENTS_MAX, mode: 'fifo' });
}
